<template>
  <div class="card activities-card">
    <div class="activities-header month-selection-wrapper">
      <div class="month-selection">
        <button class="btn month-nav back" @click="previousMonthClicked" type="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="btn open-month-selector" @click="openMonthModal" type="button">{{ currentMonthName }}</button>
        <button class="btn month-nav forward" @click="nextMonthClicked" type="button"><i
            class="fas fa-chevron-right"></i>
        </button>
      </div>
      <div class="add-button-wrapper">
        <button class="btn btn-sandpiper btn-icon grid-view-btn" type="button" v-hover="onHoverOver"
                @click="openGridViewClicked">
          <GridIcon/>
        </button>
      </div>
    </div>
    <div class="activities-header">
      <div class="">
        <p class="title">Geplande activiteiten</p>
      </div>
      <div class="add-button-wrapper">
        <button class="btn btn-sandpiper btn-icon add-event-btn" type="button" @click="addEventButtonClicked"
                v-hover="onHoverOverEventButton">
          <EventIcon/>
        </button>
        <button class="btn btn-sandpiper btn-icon add-activity-btn ml-2" type="button"
                @click="addActivityButtonClicked" v-hover="onHoverOverActivityButton">
          <AddIcon/>
        </button>
      </div>
    </div>
    <div class="activities-container">
      <div v-for="activityGroup in activitiesSortedByDate" :key="activityGroup.plannedDate">
        <h3>{{ formatDateMonthYear(activityGroup.plannedDate) }}</h3>
        <ActivitySmall :key="activity.id" v-for="activity in activityGroup.activities" :activity="activity"
                       :interactable="true"/>
        <!--                       :hide-title="activity.quest.type === questTypeEnum.impulse"/>-->
      </div>
    </div>
    <div class="no-activities" v-if="showNoActivitiesMessage">
      <p>Je hebt nog geen activiteiten op deze dag gepland.</p>
      <button class="btn btn-sandpiper btn-icon-text add-activity-btn btn-block" type="button"
              @click="addActivityButtonClicked" v-hover="onHoverOverActivityButton">
        <AddIcon/>
        Activiteit toevoegen
      </button>
    </div>
    <HoverInfo :show="hoveringOver" :content="'Kalender met geplande activiteiten'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverActivityButton" :content="'Activiteiten inplannen in je agenda'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverEventButton" :content="'Voeg hier een herinnering toe aan je agenda'" :offset-y="12"
               :offset-x="12"></HoverInfo>

  </div>
</template>

<script>
import ActivitySmall from "@/components/Activities/ActivitySmall";
import DateFormatter from "@/mixins/DateFormatter";
import DateComparison from "@/mixins/DateComparison";
import log from "@/utils/logger";

import GridIcon from "@/assets/image/icons/calendar/icon-view_grid.svg?inline";
import AddIcon from "@/assets/image/icons/icon-add.svg?inline";
import EventIcon from "@/assets/image/icons/icon-reminder.svg?inline";
import {QuestTypeEnum} from "sandpiper_api";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "AgendaListViewContainer",
  components: {HoverInfo, ActivitySmall, GridIcon, AddIcon, EventIcon},
  mixins: [DateFormatter, DateComparison],
  props: {
    activities: Array,
    currentDate: Date
  },
  emits: ["add-calendar-event", "add-calendar-activity"],
  data() {
    return {
      questTypeEnum: new QuestTypeEnum(),
      hoveringOver: false,
      hoveringOverActivityButton: false,
      hoveringOverEventButton: false,
    }
  },
  computed: {
    showNoActivitiesMessage() {
      return (this.activities.length <= 0);
    },
    activitiesSortedByDate() {
      let sortedActivities = [];
      this.activities.forEach(activity => {
        if (sortedActivities.find(sortedDate => this.isSameDay(activity.plannedDate, sortedDate.plannedDate))) {
          sortedActivities.find(sortedDate => this.isSameDay(activity.plannedDate, sortedDate.plannedDate))
              .activities
              .push(activity);
        } else {
          sortedActivities.push({
            plannedDate: activity.plannedDate,
            activities: [activity],
          });
        }
      });

      return sortedActivities.sort((el1, el2) => {
        return el1.plannedDate - el2.plannedDate;
      });
    },
    currentMonthName() {
      return this.getMonthName(this.currentDate);
    }
  },
  methods: {
    dateClicked(agendaDate) {
      log.info("[AgendaContainer] date clicked: " + agendaDate)
      this.$emit("dateChanged", agendaDate);
    },
    previousMonthClicked() {
      let newDate = this.currentDate;
      newDate.setMonth(newDate.getMonth() - 1);
      this.dateClicked(newDate);
    },
    nextMonthClicked() {
      let newDate = this.currentDate;
      newDate.setMonth(newDate.getMonth() + 1);
      this.dateClicked(newDate);
    },
    openMonthModal() {
      this.$emit("openMonthModalClicked");
    },
    openGridViewClicked() {
      this.$emit("openGridViewClicked");
    },
    addEventButtonClicked() {
      this.$emit("add-calendar-event");
    },
    addActivityButtonClicked() {
      this.$emit("add-calendar-activity");
    },
    onHoverOver(state) {
      this.hoveringOver = state;
    },
    onHoverOverActivityButton(state) {
      this.hoveringOverActivityButton = state;
    },
    onHoverOverEventButton(state) {
      this.hoveringOverEventButton = state;
    },
    
  }
}
</script>

<style lang="scss" scoped>
.activities-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 21px;

  .title {
    font-size: $title-size;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.activities-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.activities-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.no-activities {
  color: $font-grey;
  font-size: $body-text-size;
}

.period-toggle-buttons {
  display: flex;

  .btn {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    color: $font-dark;
    font-size: $title-size;
    font-weight: bold;
    padding: 0.9rem 0.9rem;
    display: flex;
    margin-right: 10px;

    &.selected {
      background-color: $primary-blue;
      color: $font-light;
    }
  }
}

.month-selection-wrapper {
  align-items: initial;
  padding-left: 50px;

  @media (min-width: 992px) {
    padding-left: 0;
  }

  @media (min-width: 1200px) {
    padding-left: 50px;
  }
}

.month-selection {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1 1;

  .month-nav {
    color: $primary-blue;

    .back {

    }

    .forward {

    }
  }

  .open-month-selector {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    color: $font-dark;
    font-weight: bold;
    font-size: $title-size;
    padding: 0.375rem 1rem;
    display: flex;
  }
}

.add-button-wrapper {
  display: flex;
  flex-direction: row;
}

.btn-icon {
  padding: 18px 13px 17px;
  line-height: 0;

  svg {
    fill: $font-light;
  }

  &.grid-view-btn {
    padding: 14px;
    height: 100%;
  }

  &.add-activity-btn {
    padding: 14px;
  }

  &.add-event-btn {
    padding: 10px 12px;
  }
}

.btn-icon-text {
  svg {
    fill: $font-light;
  }
}
</style>